import { EntityType, useAppSelector } from '@frontend/common';
import { EquipmentClient } from '@frontend/equipment/api';
import { EquipmentQueryParams, IEquipment } from '@frontend/equipment/types';
import { ObjectSelectInputV2, ObjectSelectV2Props } from '@frontend/form';
import { CommonMessage, useLocale } from '@frontend/lang';
import { defaultMapWithAttributes } from '@frontend/product/badge';
import { productRequest } from '@frontend/product/events';
import { IProduct } from '@frontend/product/types';
import { resolveStore } from '@frontend/repository';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';

const ID = 'equipment-select';
export interface EquipmentSelectProps extends ObjectSelectV2Props<IEquipment, EquipmentQueryParams> {}
/**
 * @deprecated
 */
export const EquipmentSelect = (props: EquipmentSelectProps) => {
    const { locale } = useLocale();
    const resolveState = useAppSelector(useSelector, resolveStore);
    const [v, cV] = useState<IEquipment | null>(null);
    return (
        <ObjectSelectInputV2<IEquipment, EquipmentQueryParams>
            {...props}
            id={`${ID}${props.id && '-' + props.id}`}
            label={props.label || CommonMessage.OBJECTS.EQUIPMENT.DEFAULT}
            helpMessage={props.helpMessage}
            className={props.className}
            onChange={(v) => {
                props.onChange && props.onChange(v?.id || null);
                props.onChangeObject && props.onChangeObject(v);
                cV(v);
            }}
            required={props.required}
            queryParams={props.queryParams}
            value={v}
            idValue={props.value || v?.id}
            fetch={(arg) => EquipmentClient.fetchEquipments({ ...arg, sort_field: 'serial_number', sort_direction: 'asc' })}
            itemLabel={(eq) => {
                if (!resolveState.resolved?.[EntityType.PRODUCT] || !resolveState.resolved?.[EntityType.PRODUCT]?.[eq.product_id]) {
                    productRequest(eq.product_id);
                    return '';
                } else {
                    return `${eq.serial_number}, ${defaultMapWithAttributes(resolveState.resolved[EntityType.PRODUCT][eq.product_id] as IProduct, locale)}`;
                }
            }}
            isClearable={props.isClearable}
            useQueryParam={
                props.allowURLChange
                    ? {
                          param: 'equipment_id',
                          fetch: (id) =>
                              EquipmentClient.resolveEquipments([id]).then((res) => {
                                  return res.results[0];
                              })
                      }
                    : undefined
            }
        />
    );
};
